import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CancelButton, DBDropDown, DBTextField, DBCheckBox, RedoButton } from '_components';
import styles from './Common.module.css';


class AlGaitRow extends React.Component {

    remove() {
        this.props.removeChildRow(this.props.noteId, 'MLGAIT', 'XLGA', this.props.gait.XLGANO);
    }

    handlePerformed(val) {
        if (!this.props.onAssessment && val === true) {
            this.props.updateBitField(this.props.noteId, 'PTPLAN', 'PLNO', this.props.plno, 'PLGAIT', true);
        }
        if (this.props.computedChargesVisible) {
            this.props.hideComputedCharges({ noteId: this.props.noteId });
        }
    }

    render() {
        return (
            <span>
                <div className={this.props.gait.XLGAPERFORMED ? styles.row_performed : styles.row}>
                    <div className={styles.remove_button}>
                        <CancelButton title='Remove' size='extra-small' onClick={() => this.remove()} />
                    </div>
                    <div className={styles.cell_wrapper}>
                        <DBTextField
                            noteId={this.props.noteId}
                            entity='MLGAIT'
                            entityKeyColumn='XLGANO'
                            entityKeyValue={this.props.gait.XLGANO}
                            field='XLGAACTIVITY'
                            className={this.props.gait.XLGAPERFORMED && !this.props.gait.XLGAACTIVITY ? styles.col1_performed : styles.col1}
                        />
                    </div>
                    <div className={styles.cell_wrapper}>
                        <DBDropDown
                            field='XLGAGANO'
                            noteId={this.props.noteId}
                            entity='MLGAIT'
                            entityKeyColumn='XLGANO'
                            entityKeyValue={this.props.gait.XLGANO}
                            className={this.props.gait.XLGAPERFORMED && !this.props.gait.XLGAGANO ? styles.col2_gait_performed : styles.col2_gait}
                            customOptions={this.props.assdev}
                        />
                    </div>
                    <div className={styles.cell_wrapper}>
                        <DBDropDown
                            field='XLGAGLNO'
                            noteId={this.props.noteId}
                            entity='MLGAIT'
                            entityKeyColumn='XLGANO'
                            entityKeyValue={this.props.gait.XLGANO}
                            className={this.props.gait.XLGAPERFORMED && !this.props.gait.XLGAGLNO ? styles.col3_gait_performed : styles.col3_gait}
                            customOptions={this.props.levass}
                        />
                    </div>
                    <div className={styles.cell_wrapper}>
                        <DBDropDown
                            field='XLGAGSNO'
                            noteId={this.props.noteId}
                            entity='MLGAIT'
                            entityKeyColumn='XLGANO'
                            entityKeyValue={this.props.gait.XLGANO}
                            className={this.props.gait.XLGAPERFORMED && !this.props.gait.XLGAGSNO ? styles.col4_gait_performed : styles.col4_gait}
                            customOptions={this.props.surface}
                        />
                    </div>
                    <div className={styles.cell_wrapper}>
                        <DBTextField
                            noteId={this.props.noteId}
                            entity='MLGAIT'
                            entityKeyColumn='XLGANO'
                            entityKeyValue={this.props.gait.XLGANO}
                            field='XLGADISTTIME'
                            className={this.props.gait.XLGAPERFORMED && !this.props.gait.XLGADISTTIME ? styles.col5_gait_performed : styles.col5_gait}
                        />
                    </div>
                    <div className={styles.cell_wrapper}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='MLGAIT'
                            entityKeyColumn='XLGANO'
                            entityKeyValue={this.props.gait.XLGANO}
                            field='XLGAPERFORMED'
                            className={styles.col4}
                            disabled={this.props.performedDisabled}
                            onClick={(val) => this.handlePerformed(val)}
                        />
                    </div>
                    <div className={styles.cell_wrapper}>
                        <span className={styles.col5} />
                    </div>
                    {this.props.prevVisit &&
                        <div className={styles.cell_wrapper}>
                            <span className={styles.col6}>
                                <RedoButton size='extra-small' title='Performed during previous visit' />
                            </span>
                        </div>
                    }
                </div>
            </span>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        removeChildRow: bindActionCreators(noteActions.removeChildRow, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        clearFields: bindActionCreators(noteActions.clearFields, dispatch),
        hideComputedCharges: bindActionCreators(noteActions.hideComputedCharges, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));
    let gait = state.entities.notes.MLGAIT[ownprops.id];
    let prevVisit = Object.keys(state.entities.notes.MLGAITPREV)
        .find(key => (state.entities.notes.MLGAITPREV[key].NoteId === noteId &&
            state.entities.notes.MLGAITPREV[key].XLGAGANO === gait.XLGAGANO &&
            state.entities.notes.MLGAITPREV[key].XLGAACTIVITY === gait.XLGAACTIVITY
        )) !== undefined ? true : false;

    let assdev = state.entities.masterData.MLMASTERGAITASSDEV ?
        Object.keys(state.entities.masterData.MLMASTERGAITASSDEV)
            .filter(key => {
                return state.entities.masterData.MLMASTERGAITASSDEV[key].GANAME !== '';
            })
            .sort((a, b) => state.entities.masterData.MLMASTERGAITASSDEV[a].GANAME.localeCompare(state.entities.masterData.MLMASTERGAITASSDEV[b].GANAME))
            .map(key => (
                {
                    id: state.entities.masterData.MLMASTERGAITASSDEV[key].GANO,
                    value: state.entities.masterData.MLMASTERGAITASSDEV[key].GANAME
                }
            )) : [];

    let levass = state.entities.masterData.MLMASTERGAITLEVASS ?
        Object.keys(state.entities.masterData.MLMASTERGAITLEVASS)
            .filter(key => {
                return state.entities.masterData.MLMASTERGAITLEVASS[key].GLNAME !== '';
            })
            .sort((a, b) => state.entities.masterData.MLMASTERGAITLEVASS[a].GLNAME.localeCompare(state.entities.masterData.MLMASTERGAITLEVASS[b].GLNAME))
            .map(key => (
                {
                    id: state.entities.masterData.MLMASTERGAITLEVASS[key].GLNO,
                    value: state.entities.masterData.MLMASTERGAITLEVASS[key].GLNAME
                }
            )) : [];

    let surface = state.entities.masterData.MLMASTERGAITSURFACE ?
        Object.keys(state.entities.masterData.MLMASTERGAITSURFACE)
            .filter(key => {
                return state.entities.masterData.MLMASTERGAITSURFACE[key].GSNAME !== '';
            })
            .sort((a, b) => state.entities.masterData.MLMASTERGAITSURFACE[a].GSNAME.localeCompare(state.entities.masterData.MLMASTERGAITSURFACE[b].GSNAME))
            .map(key => (
                {
                    id: state.entities.masterData.MLMASTERGAITSURFACE[key].GSNO,
                    value: state.entities.masterData.MLMASTERGAITSURFACE[key].GSNAME
                }
            )) : [];

    let plno = parseInt(Object.keys(state.entities.notes.PTPLAN)
        .find(key => (state.entities.notes.PTPLAN[key].PLEVNO === pk && noteType === 1)
            || (state.entities.notes.PTPLAN[key].PLNTNO === pk && noteType !== 1)));
    let onAssessment = state.entities.notes.PTPLAN[plno] && state.entities.notes.PTPLAN[plno].PLGAIT ? true : false;
    let computedChargesVisible = state.ui.notes[noteId].computedChargesVisible;

    let performedDisabled = noteType === 3 || noteType === 4 ? true : false;

    return {
        noteId: noteId,
        xlno: xlno,
        gait: gait,
        assdev: assdev,
        levass: levass,
        surface: surface,
        prevVisit: prevVisit,
        plno,
        onAssessment,
        computedChargesVisible,
        performedDisabled
    };
}

const connectedAlGaitRow = connect(mapStateToProps, mapDispatchToProps)(AlGaitRow);
export { connectedAlGaitRow as AlGaitRow };

